import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// When the OAuth popup redirects back, extract the id_token from the hash
// and post it to the opener, then close. This runs before React mounts.
//Build from here
const _hash = new URLSearchParams(window.location.hash.slice(1));
const _idToken = _hash.get('id_token');
if (_idToken && window.opener) {
  window.opener.postMessage({ type: 'google-id-token', idToken: _idToken }, window.location.origin);
  window.close();
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><App /></React.StrictMode>);
}
